module.exports = __webpack_public_path__ + "UR.svg?4e99070f12bf6f4cde0f0833aa3b3488";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/symbols/UR.svg
// module id = 73
// module chunks = 0